import { toPattern } from 'vanilla-masker';

export const unMask = (value: any) => value.replace(/\W/g, '')

/** Celular BR: DDD + 9 + 8 dígitos (sem DDI). Trunca e evita consulta/envio com dígito a mais. */
export const CELULAR_DIGITOS_BR = 11

export const apenasDigitosCelular = (value: unknown): string =>
    unMask(String(value ?? ''))
        .replace(/\D/g, '')
        .slice(0, CELULAR_DIGITOS_BR)

const masker = (value: any, pattern: any, options: any) =>
    toPattern(value, { pattern, ...options })

const multimasker = (value: any, patterns: any, options: any) =>
    masker(
        value,
        patterns.reduce(
            (memo: any, pattern: any) => (value.length <= unMask(memo).length ? memo : pattern),
            patterns[0]
        ),
        options
    )

export const mask = (value: any, pattern: any, options?: any) =>
    typeof pattern === 'string'
        ? masker(value, pattern || '', options)
        : multimasker(value, pattern, options)

export const formatPhoneNumber = (telefone: string | number | undefined, incluirDDI: boolean = true): string => {
    if (!telefone) return "";

    let tel = telefone.toString().replace(/\D/g, "");

    if (incluirDDI) {
        if (tel.length <= 11) {
            tel = "55" + tel;
        }
        return `+${tel.replace(/^(\d{2})(\d{2})(9?\d{4})(\d{4})$/, "$1 ($2) $3-$4")}`;
    }

    if (tel.length > 11 && tel.startsWith("55")) {
        tel = tel.substring(2);
    }

    return tel.replace(/^(\d{2})(9?\d{4})(\d{4})$/, "($1) $2-$3");
};
